<template>
  <div class="main-wrapper car-booking">
    <div class="container">
      <div class="invoice-wrapper download_section">
        <div class="inv-content">
          <div class="invoice-header">
            <div class="inv-header-left">
              <h2>Tax Invoice</h2>
            </div>
            <div class="inv-header-right">
              <a href="javascript:;">
                <img src="@/assets/img/logo2.png" alt="Logo" />
              </a>
            </div>
          </div>
          <div class="flight-invoice-details">
            <div class="bus-booking-address">
              <div class="booked-add">
                Dreams Railways
                <span>299 Star Trek Drive, Panama City, Florida, 32405, USA</span>
              </div>
              <div class="booked-add info">
                Info:
                <p>
                  Seating is on a first come, first served basis unless you have purchased
                  ticket for a Reserved Seating performance. Please arrive early for best
                  seat section.
                </p>
              </div>
            </div>
            <div class="invoice-infomation">
              <div>Date: <span>05/12/2022</span></div>
              <div>Journey Date: <span>05/01/2023</span></div>
              <div class="me-0">Invoice No: <span>#00001</span></div>
            </div>
            <div class="invoice-infomation mb-0">
              <div class="station">
                <div class="station-info">
                  <div class="point-img">
                    <img src="@/assets/img/destination-bg.png" alt="" />
                  </div>
                  <div class="station-details">
                    <div>
                      <span
                        >From:
                        <span class="from-add"> Delta Hotel street,4th Ave</span></span
                      >
                    </div>
                    <div>
                      <span
                        >To:
                        <span class="from-add"> Southgate LRT Bus Stop 2217</span></span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="station">
                <div class="station-info">
                  <div class="point-img">
                    <img src="@/assets/img/destination-bg.png" alt="" />
                  </div>
                  <div class="station-details">
                    <div>
                      <span
                        >Department Time : <span class="from-add"> 8:30 AM</span></span
                      >
                    </div>
                    <div>
                      <span>Arrive Time : <span class="from-add"> 12:30 PM</span></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="station me-0 days-detail">
                <div>
                  <span>No of Days</span>
                  <span class="destination invoice-title mb-0">15 Days</span>
                </div>
                <div class="me-0">
                  <span> Upto</span>
                  <span class="destination invoice-title mb-0">1500 Km</span>
                </div>
              </div>
            </div>
          </div>
          <div class="passenger-ticket-details">
            <div class="passenger-info">
              <div class="passenger-details">
                <h6 class="invoice-title">
                  <span>Hier's infomation</span>
                  <div class="ticket-title-bg"></div>
                </h6>
                <div class="passenger-details-display">
                  <div>Hirer’s Name : <span>Jennifer Richards </span></div>
                  <div>Passport NO : <span>JAA123456 </span></div>
                  <div>Licence NO : <span>Toronto - G 28-26-23 </span></div>
                  <div>Date of birth : <span>05 Feb 1991</span></div>
                  <div>
                    Address :
                    <span>440 Balmy Beach Road, Owen Sound, Ontario, Canada</span>
                  </div>
                </div>
              </div>
              <div class="passenger-details">
                <h6 class="invoice-title">
                  <span>Car infomation</span>
                  <div class="ticket-title-bg"></div>
                </h6>
                <div class="passenger-details-display">
                  <div>Car Model : <span>Lamborghini Aventador </span></div>
                  <div>Type : <span>Aventador </span></div>
                  <div>Licence NO : <span>LI-25345</span></div>
                  <div>Expire Date : <span> 05 Feb 2026</span></div>
                </div>
              </div>
              <div class="passenger-details">
                <h6 class="invoice-title">
                  <span>Driver infomation</span>
                  <div class="ticket-title-bg"></div>
                </h6>
                <div class="passenger-details-display">
                  <div>Driver Name :<span>Jennifer Law </span></div>
                  <div>Driving Licence : <span> LI-25345 </span></div>
                  <div>Expire Date : <span>05 Feb 2026 </span></div>
                  <div>Contact : <span>0+1-613-555-0141</span></div>
                </div>
              </div>
            </div>
          </div>
          <div class="invoice-table">
            <h6 class="invoice-title">Travel Information</h6>
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th class="table_width_1">#</th>
                    <th class="table_width_2">Bus Details</th>
                    <th class="text-center">Base Fare</th>
                    <th class="text-end table_width_4">Qty</th>
                    <th class="text-end table_width_4">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td class="table-description">
                      Lamborghini Aventador - 15 Days - Driver Services - Road Fee
                    </td>
                    <td class="text-center">$560</td>
                    <td class="text-end">1</td>
                    <td class="text-end">$560</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td class="table-description">Premium location fee</td>
                    <td class="text-center">$240</td>
                    <td class="text-end">1</td>
                    <td class="text-end">$240</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer">
            <div class="table-footer-left notes"></div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td>Taxable Amount</td>
                    <td>₹800</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer">
            <div class="table-footer-left notes">
              <span></span>
            </div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td>IGST 18.0%</td>
                    <td>$144</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer totalamount-footer">
            <div class="table-footer-left">
              <span class="total-item">Total Items / Qty : 2 / 2.00</span>
            </div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td class="invoice-title">Total</td>
                    <td class="invoice-title">$944</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer payable-table">
            <div class="table-footer-left notes">
              Total amount ( in words):
              <span>USD Nine Hundred Forty-Four Dollars Only.</span>
            </div>
            <div class="text-end table-footer-right amount-payable">
              <table>
                <tbody>
                  <tr>
                    <td class="invoice-title">Amount Payable</td>
                    <td class="invoice-title">$944</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="bank-details">
            <div class="payment-info">
              <span class="payment-title">Payment Info:</span>
              <div><span>Debit Card :</span> 465 *************645</div>
              <div><span>Amount :</span> $1,815</div>
            </div>
          </div>
          <div class="terms-condition">
            <span>Terms and Conditions:</span>
            <p>
              Here we can write a additional notes for the client to get a better
              understanding of this invoice.
            </p>
          </div>
          <div class="thanks-msg text-center">Thanks for your Business</div>
        </div>
      </div>
      <div class="file-link">
        <button class="download_btn download-link">
          <i class="feather-download-cloud me-1"></i> <span>Download</span>
        </button>
        <a href="javascript:window.print()" class="print-link">
          <i class="feather-printer"></i> <span class="">Print</span>
        </a>
      </div>
    </div>
  </div>
</template>
